"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableMenu = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@lingui/core");

var _blocks = require("@bueno/blocks");

var _lists = require("../../../Action/utils/lists");

var _utils = require("../../utils");

const Status = _styledComponents.default.span`
  display: inline-block;
  margin-right: ${_blocks.spacing.tight};

  ${_blocks.ActionList} {
    max-height: 220px;
    overflow-y: auto;
  }
`;
const Label = (0, _styledComponents.default)(_blocks.BodySmall)`
  color: ${_blocks.color.theme.typography.subdued};
  margin-bottom: ${_blocks.spacing.extraTight};
`;

const EditableMenu = ({
  selected,
  options,
  onSelect,
  label,
  field
}) => {
  return /*#__PURE__*/React.createElement(Status, null, /*#__PURE__*/React.createElement(Label, null, label), /*#__PURE__*/React.createElement(_blocks.Menu, null, ({
    isOpen,
    toggle,
    close
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, field === 'status' && /*#__PURE__*/React.createElement(_blocks.Chip, {
    size: "default",
    type: "priority",
    appearance: "solid",
    priority: _utils.statusMap[selected],
    onClick: toggle
  }, (0, _lists.getStatusMap)(_core.i18n)[selected]), field === 'priority' && /*#__PURE__*/React.createElement(_blocks.Chip, {
    size: "default",
    type: "priority",
    appearance: "accent",
    priority: _utils.priorityMap[selected],
    onClick: toggle
  }, (0, _lists.getPriorityMap)(_core.i18n)[selected]), field === 'context' && /*#__PURE__*/React.createElement(_blocks.Chip, {
    size: "default",
    type: "priority",
    onClick: toggle,
    appearance: "plain"
  }, (0, _lists.getContextMap)(_core.i18n)[selected]), (field === 'assignee' || field === 'responsible') && /*#__PURE__*/React.createElement(_blocks.Chip, {
    size: "default",
    type: "selectable",
    onClick: toggle,
    appearance: "plain"
  }, selected), isOpen && /*#__PURE__*/React.createElement(_blocks.Popover, {
    right: field === 'context' ? true : undefined
  }, /*#__PURE__*/React.createElement(_blocks.ActionList, null, options.map(({
    label,
    value,
    key
  }) => /*#__PURE__*/React.createElement(_blocks.ActionItemButton, {
    key: key !== null && key !== void 0 ? key : value,
    isActive: selected === value,
    onClick: onSelect({
      [field]: value
    }, close)
  }, label)))))));
};

exports.EditableMenu = EditableMenu;